// extracted by mini-css-extract-plugin
export default {"complete-btn":"styles_complete-btn__pPEBA"};